import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { TeamPermissionEditComponent } from '../permission-container/team-permission/team-permission-edit/team-permission-edit.component';
import { TeamMembersAddComponent } from '../permission-container/team-permission/team-permission-edit/team-permission-members/team-members-add/team-members-add.component';
import { TeamMembersEditComponent } from '../permission-container/team-permission/team-permission-edit/team-permission-members/team-members-edit/team-members-edit.component';
import { TeamRoleEditComponent } from '../permission-container/team-permission/team-permission-edit/team-permission-role/team-role-edit/team-role-edit.component';
import { TeamPermissionListingComponent } from '../permission-container/team-permission/team-permission-listing/team-permission-listing.component';
import { ViewColumn } from '../../../view-column';

@Injectable()

// This is where we need to change the view columns.
export class TeamPermissionPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, TeamPermissionListingComponent, 'Team Permission Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, TeamPermissionListingComponent, 'Team Permission Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, TeamPermissionEditComponent, 'Edit Team Permissions', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(2, TeamMembersAddComponent, 'Add Member', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(3, TeamMembersEditComponent, 'Edit Member', {
        deactivateReturn: false,
        selectedIndex: 0
      }),
      new ViewColumn(4, TeamRoleEditComponent, 'Edit Role', {
        deactivateReturn: false,
        selectedIndex: 0
      })
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
